import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { INDUSTRIES, IMAGES } from "@/data/content";

export default function Industries() {
  return (
    <div data-testid="page-industries">
      <PageHero
        overline="— Industries"
        title="Who we"
        accent="work with."
        body="From independent cabinet shops to design-build firms and private residential clients — the studio is structured to support both creative and manufacturing-driven organizations."
        image={IMAGES.millwork}
        testid="industries-hero"
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24" data-testid="industries-grid">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.title} delay={i * 40}>
              <div className="dl-card p-8 h-full">
                <div className="num text-3xl text-[#B58B5D] mb-3">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-serif text-xl text-[#EAEAEA] mb-3">{ind.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed">{ind.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
